// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__8n32G"};